import { QueryClient as e } from "./contact-channels73.js";
const t = new e();
export {
  t as queryClient
};
//# sourceMappingURL=contact-channels62.js.map
